<template>
  <div>
    <el-table
v-loading="loading"
:data="data"
size="medium"
border
stripe
>
      <el-table-column
label="STT"
width="80"
fixed="left"
align="center">
        <template slot-scope="scope">
          <span>
            {{ scope.row.stt }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="field in fields"
        :key="field.key"
        :prop="field.key"
        :label="field.label"
        :width="field.width"
      >
        <template slot-scope="scope">
          <div
v-if="field.key === 'preview'"
class="media-preview">
            <FileCard
              :key="scope.row.id"
              :file="scope.row"
              :type="selectedFileType.key"
            />
          </div>
          <span v-else-if="field.key === 'name' || field.key === 'author'">
            {{ scope.row.extra[field.key] }}
          </span>
          <span v-else-if="field.key === 'size'">
            {{ scope.row[field.key] | formatFileSize }}
          </span>
          <span v-else>
            {{ scope.row[field.key] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Thao tác"
        width="200"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <el-row
type="flex"
justify="center">
            <el-tooltip
v-if="permission.UPDATE"
content="Sửa"
effect="dark"
placement="top">
              <el-button
                icon="el-icon-edit"
                type="primary"
                size="medium"
                circle
                @click="() => $emit('update', scope.row)"
              />
            </el-tooltip>
            <el-tooltip
v-if="permission.DELETE"
content="Xoá"
effect="dark"
placement="top">
              <el-button
                icon="el-icon-delete"
                type="danger"
                size="medium"
                circle
                @click="() => $emit('delete', scope.row)"
              />
            </el-tooltip>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import constants from "@/config/constants";
import FileCard from "../../../components/items/FileCard.vue";

export default {
  name: "CardList",
  components: {
    FileCard,
  },
  props: {
    data: Array,
    loading: Boolean,
    selectedFileType: Object,
    permission: Object
  },
  data() {
    return {
      fileType: constants.FILE_TYPE,
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "preview",
          label: "",
          width:
            this.selectedFileType.key === this.fileType.AUDIO
              ? "200px"
              : "100px",
        },
        {
          key: "name",
          label: "Tên file",
        },
        {
          key: "author",
          label: "Tác giả",
        },
        {
          key: "size",
          label: "Kích thước",
        },
        {
          key: "file_type",
          label: "Loại",
        },
      ];
    },
  },
  methods: {
    //
  },
};
</script>

<style lang="scss">
.media-preview {
  .file-card-item {
    .file-image {
      width: 56px;
      height: 56px;
      border-radius: 8px;
      object-fit: cover;
      cursor: pointer;
      border: 1px solid #409eff;
    }
    .file-video {
      width: 56px;
      height: 56px;
      border-radius: 8px;
      cursor: pointer;
      border: 1px solid #409eff;
    }
    .file-audio {
      width: 100% !important;
    }
    .file-other {
      width: 56px;
      height: 56px;
      border-radius: 8px;
      object-fit: cover;
    }
  }
}
</style>
